/** Sub-pixel slack so fractional zoom never leaves the hint stuck at the bottom. */
const SCROLL_END_SLACK_PX = 2;

export function hasMoreBelow({
  scrollTop,
  clientHeight,
  scrollHeight,
}: {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
}): boolean {
  return scrollHeight - clientHeight - scrollTop > SCROLL_END_SLACK_PX;
}
